/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_FinnishInputs */

const en_speechmatics_target_language_finnish = /** @type {(inputs: Speechmatics_Target_Language_FinnishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finnish`)
};

const fr_speechmatics_target_language_finnish = /** @type {(inputs: Speechmatics_Target_Language_FinnishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finnois`)
};

const de_speechmatics_target_language_finnish = /** @type {(inputs: Speechmatics_Target_Language_FinnishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`finnisch`)
};

const it_speechmatics_target_language_finnish = /** @type {(inputs: Speechmatics_Target_Language_FinnishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`finlandese`)
};

const ru_speechmatics_target_language_finnish = /** @type {(inputs: Speechmatics_Target_Language_FinnishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`финский`)
};

const es_speechmatics_target_language_finnish = /** @type {(inputs: Speechmatics_Target_Language_FinnishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`finlandés`)
};

const zh_cn2_speechmatics_target_language_finnish = /** @type {(inputs: Speechmatics_Target_Language_FinnishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`芬兰`)
};

const ja_speechmatics_target_language_finnish = /** @type {(inputs: Speechmatics_Target_Language_FinnishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィンランド語`)
};

const hi_speechmatics_target_language_finnish = /** @type {(inputs: Speechmatics_Target_Language_FinnishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिनिश`)
};

const pt_pt2_speechmatics_target_language_finnish = /** @type {(inputs: Speechmatics_Target_Language_FinnishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`finlandês`)
};

/**
* | output |
* | --- |
* | "Finnish" |
*
* @param {Speechmatics_Target_Language_FinnishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_finnish = /** @type {((inputs?: Speechmatics_Target_Language_FinnishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_FinnishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_finnish(inputs)
	if (locale === "de") return de_speechmatics_target_language_finnish(inputs)
	if (locale === "it") return it_speechmatics_target_language_finnish(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_finnish(inputs)
	if (locale === "es") return es_speechmatics_target_language_finnish(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_finnish(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_finnish(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_finnish(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_finnish(inputs)
	return en_speechmatics_target_language_finnish(inputs)
});